module.exports = __webpack_public_path__ + "static/img/3.6efae23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/test/3.png
// module id = k3BD
// module chunks = 1